__webpack_require__.p = "/crypto-prices-updates/";